import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/ui/page-header";
import { Target, Wallet, ClipboardList } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import Goals from "./Goals";
import Budgets from "./Budgets";

const Planning = () => {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") === "goals" ? "goals" : "budgets";

  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl space-y-6">
      <PageHeader
        icon={ClipboardList}
        title="Planning"
        description="Manage your financial goals and budget plans"
      />

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="budgets" className="flex items-center gap-2">
            <Wallet className="h-4 w-4" />
            Budgets
          </TabsTrigger>
          <TabsTrigger value="goals" className="flex items-center gap-2">
            <Target className="h-4 w-4" />
            Goals
          </TabsTrigger>
        </TabsList>
        <TabsContent value="budgets" className="mt-6">
          <Budgets embedded />
        </TabsContent>
        <TabsContent value="goals" className="mt-6">
          <Goals embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Planning;
